import { createSelector } from 'reselect'
import { EmptyArray } from 'lib/array/arrayUtils'
import getLoyaltyLoungePassItemViews from 'checkout/selectors/view/itemViews/getLoyaltyLoungePassItemViews'
import { getPromoKeyForLoyaltyItem } from 'lib/promo/promoMappers'

const getCheckoutLoungePassPointsCalculationRequest = createSelector(
  (state: App.State) => getLoyaltyLoungePassItemViews(state),
  (state: App.State) => state.checkout.promo?.loyaltyPointsBonusResultV1,
  (loungePassViews, loyaltyPointsBonusResultV1): Array<App.LoyaltyPointsEarnCalculationRequest> => {
    if (!loungePassViews.hasRequiredData) return EmptyArray

    return loungePassViews.data.map((itemView): App.LoyaltyPointsEarnCalculationRequest => ({
      price: itemView.totals.price,
      loyaltyProductType: 'experience',
      itemId: itemView.item.itemId,
      promoKey: getPromoKeyForLoyaltyItem(loyaltyPointsBonusResultV1, { filter: { itemId: itemView.item.itemId } }),
    }))
  },
)

export default getCheckoutLoungePassPointsCalculationRequest
